import React, {FC, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../helpers'
// import {Item1} from '../../content/activity/Item1'
// import {Item2} from '../../content/activity/Item2'
// import {Item3} from '../../content/activity/Item3'
// import {Item4} from '../../content/activity/Item4'
// import {Item5} from '../../content/activity/Item5'
// import {Item6} from '../../content/activity/Item6'
// import {Item7} from '../../content/activity/Item7'
// import {Item8} from '../../content/activity/Item8'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {useNavigate} from 'react-router-dom'
import {callSP} from 'setup/axios/AxiosCallSP'
import {getUserByToken} from 'app/helpers/getUserByToken'
import * as auth from '../../../../app/modules/auth/redux/AuthRedux'
import {Loading} from '../../../../app/utils/loadingR/Loading'

const ActivityDrawer: FC<any> = () => {
  const [load, setLoad] = React.useState(false)
  let notifications: any = []
  notifications = useSelector<RootState>(({auth}) => auth.notifications, shallowEqual)
  const accessToken: any = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    fetchNotifications()
  }, [])

  const onGo = (id: string, type: number, data: any) => {
    if (type !== 1) {
      navigate('/minutas/minutaFood', {
        state: {
          contrato: id,
          params: {...data, id_contrato: data.link},
        },
      })
    }

    if (type !== 2) {
      navigate('/plantillas/plantillaVertical', {
        state: {
          contrato: id,
          params: data,
        },
      })
    }
  }

  const onclose = async (item: any) => {
    const user: any = await getUserByToken(accessToken)

    const arrayData = [
      {text: 'tabla', value: 'amd_alertas_leidas'},
      {
        text: 'columnas',
        value: 'idUsuario,estado,fecha,idAlerta',
      },
      {
        text: 'valores',
        value: `${user.idUser ? user.idUser.toString() : user.id.toStriing()},0,${new Date().toISOString().substring(0, 10)}, ${item.id}`,
      },
    ]
    const {data} = await callSP('amd_InsertTable', arrayData)
    if (data.status == 200) {
      await fetchNotifications()
    }
  }

  const fetchNotifications = async () => {
    const user: any = await getUserByToken(accessToken)
    try {
      setLoad(true)
      const response = await callSP('amd_getAlertasByUsuario', [
        {text: 'usuario', value: user.idUser ? user.idUser.toString() : user.id.toStriing()},
      ])
      const result = response.data.result
      if (Array.isArray(result)) {
        dispatch(auth.actions.setNotifications(result))
      }
      setLoad(false)
    } catch (e: any) {
      setLoad(false)
    }
  }

  return (
    <>
      <Loading open={load} />

      <div
        id='kt_activities'
        className='bg-white'
        data-kt-drawer='true'
        data-kt-drawer-name='activities'
        data-kt-drawer-activate='true'
        data-kt-drawer-overlay='true'
        data-kt-drawer-width="{default:'300px', 'lg': 'auto'}"
        data-kt-drawer-direction='end'
        data-kt-drawer-toggle='#kt_activities_toggle'
        data-kt-drawer-close='#kt_activities_close'
      >
        <div className='card shadow-none rounded-0'>
          <div className='card-header' id='kt_activities_header'>
            <h3 className='card-title fw-bolder text-dark'>Notificaciones</h3>

            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-active-light-primary me-n5'
                id='kt_activities_close'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </button>
            </div>
          </div>
          <div className='card-body position-relative' id='kt_activities_body'>
            <div
              id='kt_activities_scroll'
              className='position-relative scroll-y me-n5 pe-5'
              data-kt-scroll='true'
              data-kt-scroll-height='auto'
              data-kt-scroll-wrappers='#kt_activities_body'
              data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
              data-kt-scroll-offset='5px'
            >
              <div className='timeline'>
                {/* <Item1 />
                <Item2 />
                <Item3 />
                <Item4 />
                <Item5 />
                <Item6 />
                <Item7 />
                <Item8 /> */}

                {notifications && notifications?.length == 0 &&
                <div>
                  Sin Notificaciones
                </div>}
              </div>
            </div>
          </div>
          <div className='card-footer py-5 text-center' id='kt_activities_footer'>
            {/* View All Activities */}
            {/* <Link to='/crafted/pages/profile' className='btn btn-bg-white text-primary'>
              Ver todas las actividades
              <KTSVG
                path='/media/icons/duotune/arrows/arr064.svg'
                className='svg-icon-3 svg-icon-primary'
              />
            </Link> */}
          </div>
        </div>
      </div>
    </>
  )
}

export {ActivityDrawer}
